const Data = [
    {
        id: 16,
        title: "Protecting Your Manufacturing Floor: How Blackberry Cylance Defends Against Cybersecurity Threats without Disrupting Operations",
        img: "/assets/img/Linkedin/1674040738304.png",
        link:"https://www.scriptics.ai/blackberry-cylance-defends"
    },
    {
        id: 7,
        title: "Powering Data-Driven Decisions: A Guide to Creating the Ultimate Business Dashboard with Scriptics'​ Expertise",
        img: "/assets/img/Linkedin/1677442688857.png",
        link:"https://www.linkedin.com/pulse/powering-data-driven-decisions-guide-creating-ultimate/?trackingId=taEmpd%2B9g690eCSw%2FSurrw%3D%3D"
    },
    {
      id: 2,
      title: "Maximizing Customer Satisfaction and Revenue Growth: Discover the Power of Scriptics's Customized CRM Solutions ",
      img: "/assets/img/Linkedin/1677837345328.jpg",
      link:"https://www.linkedin.com/pulse/maximizing-customer-satisfaction-revenue-growth-discover/?trackingId=tlsDLN1pTcBxX5hQA2Wv3g%3D%3D"
    },
    {
      id: 1,
      title: "Which bot is a bot with benefits for your business?",
      img: "/assets/img/Linkedin/1678641220959.png",
      link:"https://www.linkedin.com/pulse/which-bot-benefits-your-business-scripticstechs/"
    },
    {
      id: 5,
      title: "Blackberry cyber security products and service",
      img: "/assets/img/Linkedin/1676901177606.jpg",
      link:"https://www.linkedin.com/pulse/blackberry-cyber-security-products-service-scripticstechs/?trackingId=9eIRJTzRbzE8%2BtCCXQnkzQ%3D%3D"
    },
    {
        id: 4,
        title: "Scriptics Takes on the Next Generation of Application Re-engineering Challenges with Cutting-Edge Solutions",
        img: "/assets/img/Linkedin/1677688974102.png",
        link:"https://www.linkedin.com/pulse/scriptics-takes-next-generation-application-re-engineering/"
    },
    {
        id: 6,
        title: "Efficient Cloud Infrastructure Management with Scriptics Technologies: Automating Tasks on AWS, Azure, and GCP",
        img: "/assets/img/Linkedin/1677784732908.png",
        link:"https://www.linkedin.com/pulse/efficient-cloud-infrastructure-management-scriptics-technologies/"
    },
    {
        id: 3,
        title: "Azure Docker V/s Legacy Apps",
        img: "/assets/img/Linkedin/1676998792458.png",
        link:"https://www.linkedin.com/pulse/azure-docker-vs-legacy-apps-scripticstechs/"
    },
    {
        id: 8,
        title: "Importance of web analytics for e-commerce business.",
        img: "/assets/img/Linkedin/1677157587750.png",
        link:"https://www.linkedin.com/pulse/importance-web-analytics-e-commerce-business-scripticstechs/"
    },
    {
        id: 9,
        title: "Assessing Risk and Ability to Pay: The Vital Role of Models for Fintech and Lending Companies",
        img: "/assets/img/Linkedin/1678264037628.png",
        link:"https://www.linkedin.com/pulse/assessing-risk-ability-pay-vital-role-models-fintech/"
    },
    {
        id: 10,
        title: "The first question for business: Which cloud service provider to choose?",
        img: "/assets/img/Linkedin/1674040738303.png",
        link:"https://www.linkedin.com/pulse/first-question-business-which-cloud-service-provider-choose-/"
    },
    {
        id: 11,
        title: "Scriptics Introducing our 3D treatment planning viewer",
        img: "/assets/img/Linkedin/1671145203376.jpg",
        link:"https://www.linkedin.com/posts/scripticstechs_digital-manufacturing-opensource-activity-7009291018915196929-_zWI?utm_source=share&utm_medium=member_desktop"
    },
    {
        id: 12,
        title: "Ai for your business in 2023.",
        img: "/assets/img/Linkedin/1672933543460.png",
        link:"https://www.linkedin.com/pulse/ai-your-business-2023-scripticstechs/"
    },
    {
        id: 13,
        title: "VDI: Should be a Very Detailed Integration with your existing infrastructure.",
        img: "/assets/img/Linkedin/1672825416792.png",
        link:"https://www.linkedin.com/pulse/vdi-should-very-detailed-integration-your-existing-infrastructure-/"
    },
    {
        id: 14,
        title: "Unified to Simplified: Hyper converged Infrastructure",
        img: "/assets/img/Linkedin/1667486908282.jpg",
        link:"https://www.linkedin.com/pulse/unified-simplified-hyper-converged-infrastructure-scripticstechs/"
    },
    {
        id: 15,
        title: "East or west: Your cloud service provider should be the best.",
        img: "/assets/img/Linkedin/1667398057174.jpg",
        link:"https://www.linkedin.com/pulse/east-west-your-cloud-service-provider-should-best-scripticstechs/"
    },
    
  ];
  
  export { Data };
  